<template>
  <div class="order-more">
    <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/order-list')"> 
      <p>
        订单详情
      </p>
    </header>
    <section>
      <div class="order-msg">
        <!-- 标题 -->
        <p class="order-title">
          <span>
            珍爱女性相约浪漫女人岛
          </span>
          <span>
            已支付
          </span>
        </p>
        <p class="order-img">
          <img src="../../assets/images/order-img/order-more-img/event-img.png" alt="">
        </p>
        <!-- 订单信息 -->
        <div class="o-msg">
          <p>
            购买日期：
          </p>
          <p>
            2020/3/18   15:30
          </p>
        </div>
        <div class="o-msg">
          <p>
            下单人姓名：
          </p>
          <p>
            周刚
          </p>
        </div>
        <div class="o-msg">
          <p>
            实际付款：
          </p>
          <p>
            3999元
          </p>
        </div>
        <div class="o-msg">
          <p>
            联系方式：
          </p>
          <p>
            18888888888
          </p>
        </div>
        <div class="o-msg">
          <p>
            身份证号码：
          </p>
          <p>
            372933188811120033
          </p>
        </div>
        <div class="o-msg">
          <p>
            会员编号：
          </p>
          <p>
            020202020
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .order-more{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
      flex: 1;
      background-image: url(../../assets/images/order-img/order-more-img/touming.png);
      background-repeat: no-repeat;
      background-size: 7.5rem 5.46rem;
      .order-msg{
        width: 6.9rem;
        height: 9.32rem;
        background: #ffffff;
        border-radius: .2rem;
        margin: 0 auto;
        margin-top: .99rem;
        .order-title{
          span{
            &:first-child{
              display: inline-block;
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: bold;
              color:rgba(51,51,51,1);
              line-height: .36rem;
              margin-left: .19rem;
              margin-top: .39rem;
            }
            &:last-child{
              font-size: 0.28rem;
              font-family: PingFang SC;
              font-weight: bold;
              color:rgba(239,130,1,1);
              line-height: .36rem;
              margin-left: 1.6rem;
            }
          }
        }
        .order-img{
          img{
            width: 2.24rem;
            height: 1.33rem;
            margin-left: .21rem;
            margin-top: .19rem;
          }
        }
        .o-msg{
          width: 6.46rem;
          height: .88rem;
          margin: 0 auto;
          border-bottom: .01rem #E4E4E4 solid;
          line-height: .88rem;
          p{
            &:first-child{
              float: left;
              font-family: PingFang-SC;
              color: #333333;
              font-size: 0.3rem;
            }
            &:last-child{
              float: right;
              font-family: PingFang-SC;
              color: #999999;
              font-size: 0.3rem;
            }
          }
        }
      }
    }
  }
</style>